import Vue from 'vue'
import Vuex from 'vuex'
import router from './../router'
import {GroupPersistance, Groupie} from '@zocom/toolie-core/dist';

// Instanciate 
let groupPersistance = new GroupPersistance();
let groupie = new Groupie();

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    roster: [],
    UIstate: {
      groupPersistance: false,
      menuOptions: {
        navicon: true,
        close: false,
        back: false,
        crossGroups: false,
        remix: false,
        screenshot: false,
        share: false
      }
    },
    generatedGroups: [],
    persistentGroups: []
  },
  mutations: {
    configMenuUI(state, newState){
      state.UIstate.menuOptions = { ...state.UIstate.menuOptions, ...newState }
    },
    updateRoster(state, roster){
      state.roster = roster.split('\n');
    },
    updatePersistentGroups(state, groups){
      state.persistentGroups = groups;
    },
    toggleGroupPersistance(state){
      state.UIstate.groupPersistance = !state.UIstate.groupPersistance;
    },
    setGeneratedGroups(state, groups){
      state.generatedGroups = groups;
    }
  },
  actions: {
    async readPersistentGroups({ commit }){
      
      const groups = groupPersistance.read();

      if(groups){
        commit('updatePersistentGroups', groups);
      } else {
        commit('updatePersistentGroups', []);
      }

    },
    savePersistentGroup({ dispatch, state }, newGroup){
      groupPersistance.create(state.roster, newGroup.name);
      dispatch('readPersistentGroups');
    },
    async deletePersistentGroup({ dispatch }, groupId){
      groupPersistance.delete(groupId);
      await dispatch('readPersistentGroups');
    },
    generateGroups({ commit, state }, settings){

      groupie.everyone = state.roster;

      groupie.createGroups({
        enableFunnyNames: settings.name,
        enableLeader: settings.leader,
        groupSize: settings.size,
      });

      commit('setGeneratedGroups', groupie.groups);
      router.push('/groups')
    },
    createCrossGroups({commit}){
      groupie.createCrossGroups();
      commit('setGeneratedGroups', groupie.groups);

    },
    remixGroups({commit}){
      groupie.recreateGroups();
      commit('setGeneratedGroups', groupie.groups);
    }
  }
})